import React, { useState, useEffect, useRef } from "react";
import css from "../css/gamehis.module.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ReactPaginate from "react-paginate";
import axios from "axios";
import Invoice from "./Invoice";
import { AiOutlineDownload } from "react-icons/ai";
import "./invoice.css";
import socket from "../Components/socket";

import { BsFillEyeFill } from "react-icons/bs";
import { apiRequest } from "../store/allApi";
import { FaRocketchat } from "react-icons/fa6";
import $ from "jquery";
const Transactionhistory = () => {
  // const [invoiceData, setInvoiceData] = useState("");
  // const [cardData, setGame] = useState();

  // const handleClose = () => setShow(false);
  // const handleShow = (e) => {
  //   setShow(true);
  //   setInvoiceData(e);
  // };

  // const handlePageClick = async (data) => {
  //   let currentPage = data.selected + 1;
  //   setPageNumber(currentPage);
  // };

  // const [Withdrawal, setWithdrawal] = useState();
  // const [showBottom, setShowBottom] = useState(false);

  // const handleCloseBottom = () => setShowBottom(false);
  // const handleShowBottom = (data) => {
  //   setShowBottom(true);
  //   setWithdrawal(data);
  // };

  // BASE URL
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;

  const [activeTab, setActiveTab] = useState("wallet");
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  let printRef = useRef(null);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [user, setUser] = useState("");
  let limit = 50;
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const role = async () => {
    socket.emit("getprofile");

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`me`, "GET", null, headers);
      if (res.data) {
        setUser(res.data);
        fetchData(res?.data?._id, pageNumber, limit);
      }
    } catch (e) {
      // setLoading(false)
    }
  };

  // ALL APIS HERE

  const [walletData, setWalletData] = useState([]);
  const [gameData, setGameData] = useState([]);
  const [penaltyData, setPenaltyData] = useState([]);
  const [bonusData, setBonusData] = useState([]);

  const fetchData = async (id, pageNumber, limit) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    setIsLoading(true);

    try {
      const res = await apiRequest(
        `temp/deposite/${id}?page=${pageNumber}&_limit=${limit}`,
        "GET",
        null,
        headers,
      );

      if (res) {
        const data = res.data.ress;

        // Filter data based on Req_type
        const walletData = data.filter(
          (item) => item.Req_type !== "penalty" && item.Req_type !== "bonus",
        );
        const penaltyData = data.filter((item) => item.Req_type === "penalty");
        const bonusData = data.filter((item) => item.Req_type === "bonus");

        setWalletData(walletData);
        setPenaltyData(penaltyData);
        setBonusData(bonusData);
        setNumberOfPages(res.data.totalPages);
      }

      // Fetch game data

      const gameRes = await apiRequest(
        `game/history/user/${id}?page=${pageNumber}&_limit=${limit}`,
        "GET",
        null,
        headers,
      );
      if (gameRes) {
        setGameData(gameRes?.data?.data);
      }

      setIsLoading(false);
    } catch (e) {
      // setLoading(false)
    }
  };

  useEffect(() => {
    role();
  }, [pageNumber, limit]);

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
    return newDate;
  };

  return (
    <>
      <div className="leftContainer mb_space">
        <div className="Orher_page_main_section">
          <section className="transaction_main_section_modal">
            <h2 className="profile_headings mt-5 pt-1"></h2>
            <ul className="nav nav-tabs" role="tablist">
              {[
                { id: "wallet", label: "Wallet" },
                { id: "game", label: "Game" },
                { id: "penalty", label: "Penalty" },
                { id: "bonus", label: "Bonus" },
              ].map(({ id, label }) => (
                <li className="nav-item" role="presentation" key={id}>
                  <button
                    className={`nav-link ${activeTab === id ? "active" : ""}`}
                    onClick={() => setActiveTab(id)}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>

            <div className="tab-content">
              {activeTab === "wallet" && (
                <div className="tab-pane fade show active">
                  {isLoading ? (
                    <div className="text-center">
                      {walletData?.length === 0 ? (
                        <div className="mt-2">
                          <h3 className="font-weight-bold">
                            No Wallet History
                          </h3>
                          <p className="text-muted">
                            You have not made any wallet transactions yet.
                          </p>
                        </div>
                      ) : (
                        <div
                          className="loaderReturn text-center"
                          style={{ zIndex: "99" }}
                        >
                          <img
                            src={"/images/LandingPage_img/loader1.gif"}
                            style={{ width: "100%" }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    walletData?.length === 0 && (
                      <div className="mt-3 text-center">
                        <h3 className="font-weight-bold">No Wallet History</h3>
                        <p className="text-muted">
                          You have not made any wallet transactions yet.
                        </p>
                      </div>
                    )
                  )}
                  {walletData?.map((walletData) => (
                    <div
                      className="transaction_premium_card"
                      key={walletData?._id}
                    >
                      <div className="trans_card_inner">
                        {/* Left Side: Title & Info */}
                        <div className="trans_info_main">
                          <h3 className="trans_title">
                            {walletData?.titleMsg}
                          </h3>
                          <div className="trans_meta_row">
                            <span className="meta_pill type_pill">
                              {walletData?.Req_type}
                            </span>
                            <span
                              className={`meta_pill status_pill ${
                                walletData?.status === "PAID" ||
                                walletData?.status === "SUCCESS"
                                  ? "status_success"
                                  : "status_default"
                              }`}
                            >
                              {walletData?.status}
                            </span>
                          </div>

                          {walletData?.txn_msg && (
                            <p className="trans_message_text">
                              {walletData?.txn_msg}
                            </p>
                          )}

                          {walletData?.closing_balance && (
                            <div className="trans_closing_bal">
                              Closing Balance:{" "}
                              <strong>₹{walletData?.closing_balance}</strong>
                            </div>
                          )}
                        </div>

                        {/* Right Side: Amount & Date */}
                        <div className="trans_amount_side">
                          <div
                            className={`amount_display_box ${
                              walletData?.status === "PAID"
                                ? "amt_plus"
                                : walletData?.status === "SUCCESS"
                                  ? "amt_minus"
                                  : "amt_neutral"
                            }`}
                          >
                            <span className="amt_symbol">
                              {walletData?.status === "PAID"
                                ? "+"
                                : walletData?.status === "SUCCESS"
                                  ? "-"
                                  : ""}
                            </span>
                            <span className="amt_currency">₹</span>
                            <span className="amt_value">
                              {walletData?.amount}
                            </span>
                          </div>

                          <div className="trans_date_box">
                            <span className="d_date">
                              {dateFormat(walletData?.createdAt).split(",")[0]}
                            </span>
                            <span className="d_time">
                              {dateFormat(walletData?.createdAt).split(",")[1]}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "penalty" && (
                <div className="tab-pane fade show active">
                  {isLoading ? (
                    <div className="text-center">
                      {penaltyData.length === 0 ? (
                        <div className="mt-2">
                          <h3 className="font-weight-bold">
                            No Penalty History
                          </h3>
                          <p className="text-muted">
                            You have not made any penalty transactions yet.
                          </p>
                        </div>
                      ) : (
                        <div
                          className="loaderReturn text-center"
                          style={{ zIndex: "99" }}
                        >
                          <img
                            src={"/images/LandingPage_img/loader1.gif"}
                            style={{ width: "100%" }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    penaltyData.length === 0 && (
                      <div className="mt-3 text-center">
                        <h3 className="font-weight-bold">No Penalty History</h3>
                        <p className="text-muted">
                          You have not made any penalty transactions yet.
                        </p>
                      </div>
                    )
                  )}
                  {penaltyData.map((card) => (
                    <div
                      className={`wallet_transaction_card_new ${card?.status === "SUCCESS" || card?.status === "PAID" ? "success_theme_bg" : "failed_theme_bg"}`}
                      key={card?._id}
                    >
                      <div className="wallet_card_inner_flex">
                        {/* Left Side: Detail & Status */}
                        <div className="wallet_left_info">
                          <h3 className="wallet_title_modern">
                            {card?.titleMsg}
                          </h3>

                          <div className="wallet_tag_row">
                            <span className="type_tag">{card?.Req_type}</span>
                            <span
                              className={`status_tag_pill ${card?.status === "SUCCESS" || card?.status === "PAID" ? "success_pill" : "default_pill"}`}
                            >
                              {card?.status}
                            </span>
                          </div>

                          {card?.txn_msg && (
                            <p className="wallet_txn_msg_text">
                              {card?.txn_msg}
                            </p>
                          )}

                          {card?.closing_balance && (
                            <div className="wallet_closing_box">
                              Closing Balance:{" "}
                              <strong>₹{card?.closing_balance}</strong>
                            </div>
                          )}
                        </div>

                        {/* Right Side: Amount & Time */}
                        <div className="wallet_right_info">
                          <div
                            className={`amount_badge_modern ${card?.status === "SUCCESS" || card?.status === "PAID" ? "amt_green" : "amt_red"}`}
                          >
                            <span className="sign_text">
                              {card?.status === "PAID" ? "(+)" : "(-)"}
                            </span>
                            <span className="currency_text">₹</span>
                            <span className="value_text">{card?.amount}</span>
                          </div>

                          <div className="timestamp_box_modern">
                            <span className="date_text">
                              {dateFormat(card?.createdAt).split(",")[0]}
                            </span>
                            <span className="time_text">
                              {dateFormat(card?.createdAt).split(",")[1]}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "bonus" && (
                <div className="tab-pane fade show active">
                  {isLoading ? (
                    <div className="text-center">
                      {bonusData.length === 0 ? (
                        <div className="mt-2">
                          <h3 className="font-weight-bold">No Bonus History</h3>
                          <p className="text-muted">
                            You have not received any bonuses yet.
                          </p>
                        </div>
                      ) : (
                        <div
                          className="loaderReturn text-center"
                          style={{ zIndex: "99" }}
                        >
                          <img
                            src={"/images/LandingPage_img/loader1.gif"}
                            style={{ width: "100%" }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    bonusData.length === 0 && (
                      <div className="mt-3 text-center">
                        <h3 className="font-weight-bold">No Bonus History</h3>
                        <p className="text-muted">
                          You have not received any bonuses yet.
                        </p>
                      </div>
                    )
                  )}
                  {bonusData.map((card) => (
                    <div
                      className={`transaction-modern-wrapper ${card?.status === "SUCCESS" || card?.status === "PAID" ? "theme-success" : "theme-pending"}`}
                      key={card?._id}
                    >
                      <div className="transaction-glass-card">
                        <div className="card-top-row">
                          {/* Left: Message & Type */}
                          <div className="info-main-stack">
                            <h4 className="transaction-title-text">
                              {card?.titleMsg}
                            </h4>
                            <div className="badge-row-flex">
                              <span className="type-badge-pill">
                                {card?.Req_type}
                              </span>
                              <span
                                className={`status-text-pill ${card?.status === "SUCCESS" || card?.status === "PAID" ? "color-green" : "color-normal"}`}
                              >
                                {card?.status}
                              </span>
                            </div>
                          </div>

                          {/* Right: Amount Styling */}
                          <div className="amount-stack-right">
                            <div
                              className={`amount-vibe ${card?.status === "SUCCESS" || card?.status === "PAID" ? "amt-plus" : "amt-neutral"}`}
                            >
                              <span className="math-symbol">
                                {card?.status === "PAID" ? "+" : ""}
                              </span>
                              <span className="rupee-symbol">₹</span>
                              <span className="main-val">{card?.amount}</span>
                            </div>
                          </div>
                        </div>

                        {/* Bottom: Divider & Footer Details */}
                        <div className="card-footer-divider"></div>

                        <div className="card-bottom-row">
                          <div className="balance-group-vertical">
                            {card?.txn_msg && (
                              <p className="txn-warning-text">
                                {card?.txn_msg}
                              </p>
                            )}
                            {card?.closing_balance && (
                              <div className="closing-bal-badge">
                                <label>Closing Balance</label>
                                <strong>₹{card?.closing_balance}</strong>
                              </div>
                            )}
                          </div>

                          <div className="timestamp-data-stack">
                            <div className="date-pill">
                              <i className="fa fa-calendar-o"></i>{" "}
                              {dateFormat(card?.createdAt).split(",")[0]}
                            </div>
                            <div className="time-pill">
                              <i className="fa fa-clock-o"></i>{" "}
                              {dateFormat(card?.createdAt).split(",")[1]}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "game" && (
                <div className="tab-pane fade show active">
                  {isLoading ? (
                    <div className="text-center">
                      {gameData?.length === 0 ? (
                        <div className="mt-2">
                          <h3 className="font-weight-bold">No Game History</h3>
                          <p className="text-muted">
                            You have no game history yet.
                          </p>
                        </div>
                      ) : (
                        <div
                          className="loaderReturn text-center"
                          style={{ zIndex: "99" }}
                        >
                          <img
                            src={"/images/LandingPage_img/loader1.gif"}
                            style={{ width: "100%" }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    gameData?.length === 0 && (
                      <div className="mt-3 text-center">
                        <h3 className="font-weight-bold">No Game History</h3>
                        <p className="text-muted">
                          You have no game history yet.
                        </p>
                      </div>
                    )
                  )}
                  {gameData.map((card) => (
                    <div
                      className={`battle_card_premium ${card.Status === "completed" ? (card?.Winner?._id === user?._id ? "win_bg_premium" : "lost_bg_premium") : card.Status === "cancelled" ? "cancelled_bg_premium" : "pending_bg_premium"}`}
                      key={card?._id}
                    >
                      <div className="battle_card_content">
                        {/* Left Section: Result & Player */}
                        <div className="battle_main_info">
                          <div className="status_text_header">
                            {card.Status === "completed" ? (
                              card?.Winner &&
                              card?.Winner?._id === user?._id ? (
                                <span className="status_win">WIN AGAINST</span>
                              ) : (
                                <span className="status_lost">
                                  LOST AGAINST
                                </span>
                              )
                            ) : (
                              <span className="status_other">
                                {card?.Status.toUpperCase()}
                              </span>
                            )}
                          </div>

                          <h4 className="player_name_text">
                            {card?.Accepetd_By?.Name}
                          </h4>

                          <div className="battle_id_balance_group">
                            <p className="battle_id_bold">ID: {card?._id}</p>

                            {/* Closing Balance placed exactly below Battle ID */}
                            <div className="closing_bal_text">
                              {card.Status !== "cancelled" ? (
                                <span>
                                  Closing Balance: ₹
                                  {card?.Winner?.id === user?._id
                                    ? card?.Winner_closingbalance
                                    : card?.Loser_closingbalance}
                                </span>
                              ) : (
                                <span>
                                  Closing Balance: ₹
                                  {card?.Created_by?.id === user?._id
                                    ? card?.Loser_closingbalance
                                    : card?.Winner_closingbalance}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Right Section: Amount & Action */}
                        <div className="battle_side_info">
                          <div className="game_amt_box">
                            <small>Amount</small>
                            <h3>₹{card?.Game_Ammount}</h3>
                          </div>

                          <div className="action_footer_row">
                            <div className="date_time_stack">
                              <span>
                                {dateFormat(card?.createdAt).split(",")[0]}
                              </span>
                              <span>
                                {dateFormat(card?.createdAt).split(",")[1]}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Transactionhistory;
